/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_ClassificationsInputs */

const vi_tea_lot_classifications = /** @type {(inputs: Tea_Lot_ClassificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân loại`)
};

/**

* @param {Tea_Lot_ClassificationsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_classifications = /** @type {((inputs?: Tea_Lot_ClassificationsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_ClassificationsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_classifications(inputs)
});